import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'antd';

import { PersonSelectModel } from 'api/adminApiClient';
import { getMembersWithPartners } from 'redux/reducers/partnerSlice';
import { getFullName } from 'utils/personUtils';
import { AdminPartnersFilterEnum } from 'features/admin/partner/enums';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';
import { useAppDispatch } from 'hooks/useAppDispatch';

export interface PartnersFilters {
  [AdminPartnersFilterEnum.Member]: string[];
}

type Props = {
  filters: PartnersFilters;
  onChange: (data: PartnersFilters) => void;
  isReginteredOnMP: boolean;
};

export default function PartnersFilter(props: Props) {
  const { filters, onChange, isReginteredOnMP } = props;
  const [members, setMembers] = useState<PersonSelectModel[]>([]);
  const [isMembersLoaded, setIsMembersLoaded] = useState(false);
  const dispatch = useAppDispatch();

  const loadMembers = useCallback(async () => {
    const result = await dispatch(getMembersWithPartners(isReginteredOnMP));

    if (getMembersWithPartners.fulfilled.match(result)) {
      setMembers(result.payload);
    }
    setIsMembersLoaded(true);
  }, [dispatch, isReginteredOnMP]);

  useEffect(() => {
    loadMembers();
  }, [loadMembers]);

  const handleFilterChange =
    (type: AdminPartnersFilterEnum) => (value: string[]) => {
      onChange({
        ...filters,
        [type]: value,
      });
    };

  return (
    <Row gutter={[20, 10]}>
      <Col xs={24} md={6}>
        <SelectWithLoading
          isLoading={!isMembersLoaded}
          className="full-width"
          value={filters[AdminPartnersFilterEnum.Member]}
          mode="multiple"
          optionFilterProp="children"
          placeholder="Select the member"
          onChange={handleFilterChange(AdminPartnersFilterEnum.Member)}
          showSearch
        >
          {members.map(({ companyId, firstName, lastName, companyName }) => (
            <SelectWithLoading.Option key={companyId} value={companyId || ''}>
              {getFullName(firstName, lastName)}
              <div>
                <span className="custom-option-caption">{companyName}</span>
              </div>
            </SelectWithLoading.Option>
          ))}
        </SelectWithLoading>
      </Col>
    </Row>
  );
}
